import React from 'react';
import { TextInput } from '../../reusable-components/TextInput';

interface InvoiceDownloaderLoginFormProps {
  username: string;
  password: string;
  loading: boolean;
  onUsernameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPasswordChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onStartLogin: (e: React.FormEvent) => void;
}

export const InvoiceDownloaderLoginForm: React.FC<
  InvoiceDownloaderLoginFormProps
> = ({
  username,
  password,
  loading,
  onUsernameChange,
  onPasswordChange,
  onStartLogin,
}) => {
  return (
    <>
      <TextInput
        label="Vodafone Username:"
        value={username}
        placeholder="Enter Vodafone username"
        autocomplete="username"
        onChange={onUsernameChange}
        required={true}
        errorMessage="Username is required"
        width="w-1/3"
      />

      <TextInput
        label="Vodafone Password:"
        value={password}
        placeholder="Enter Vodafone password"
        autocomplete="current-password"
        onChange={onPasswordChange}
        onEnterKeyPressed={(e) => {
          e.preventDefault();
          if (username && password && !loading) {
            onStartLogin({
              preventDefault: () => {
                console.debug('Sending start login... enter key pressed.');
              },
            } as React.FormEvent);
          }
        }}
        fieldType="password"
        required={true}
        errorMessage="Password is required"
        width="w-1/3"
      />
    </>
  );
};
